import { apiUrl } from '../../../settings'

export const getConferenceInterestsUrl = () => {
    return apiUrl + '/api/conference/all-conferenceInterests'
}

export const deleteConferenceInterestUrl = (id) => {
    return apiUrl + `/api/conference/delete-conferenceInterest/${id}`
}
export const exportConferenceInterestUrl = () => {
    return apiUrl + `/api/conference/export-conferenceInterests`
}
